import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import ReactGA from 'react-ga';

import Loading from '../common/Loading';
import VoicemailRow from './VoicemailRow';

import './index.scss';

export default class Voicemails extends React.Component {
  constructor() {
    super();

    this.state = {
      startDate: moment().subtract(30, 'days'),
      endDate: moment(),
      isShowAll: false,
    };

    this.onReadToggleClick = this.onReadToggleClick.bind(this);
    this.onVoicemailPlayClick = this.onVoicemailPlayClick.bind(this);
    this.onShowAllChange = this.onShowAllChange.bind(this);
  }

  componentDidMount() {
    ReactGA.pageview(window.location.hash);
    ReactGA.event({
      category: 'User',
      action: 'Click on Voicemails Tab',
      label: 'Voicemails Page',
    });
    const { auth } = this.props;
    const { userid,studio_id } = auth;
    this.props.scoketHandshake(userid, studio_id);
    this.props.getVoicemails({
      startDate: this.state.startDate.valueOf(),
      endDate: this.state.endDate.valueOf(),
    });
  }
  componentWillUnmount(){
    this.props.disconnectScoket();
  }
  onVoicemailPlayClick(voicemail) {
    this.props.markVoicemail({
      id: voicemail.id,
      isRead: true,
    });
  }

  onReadToggleClick(voicemail, isRead) {
    this.props.markVoicemail({
      id: voicemail.id,
      isRead,
    });
  }

  onShowAllChange() {
    this.setState({
      isShowAll: !this.state.isShowAll,
    });
  }

  render() {
    let voicemails = [];
    const { vmloader } = this.props.voicemails;
    if (this.props.voicemails.list && this.props.voicemails.list.length) {
      voicemails = this.props.voicemails.list;
    }

    if (!this.state.isShowAll) {
      voicemails = voicemails.filter((item) => {
        return !item.isRead && !item.isHandled;
      });
    }

    return (
      <div className="voicemails">
        <div className="card">
          <div className="card__header">
            <span className="card__header__text">
              Voicemails{' '}
              <span className="card__header__text--subtitle">
                since {this.state.startDate.format('ddd, D MMM YYYY')} (last 30
                days)
              </span>
            </span>
          </div>
          <div className="card__content">
            <div className="voicemails__list">
              <div className="voicemails__list__filter">
                <input
                  type="checkbox"
                  id="selectAllVoicemails"
                  checked={this.state.isShowAll}
                  onChange={this.onShowAllChange}
                />
                <label htmlFor="selectAllVoicemails">Show All</label>
              </div>
              <div className="voicemails__list__table">
                {!vmloader ? (
                  <table>
                    <thead>
                      <tr>
                        <th />
                        <th>DATE</th>
                        <th>DURATION (secs)</th>
                        <th>FORWARDED FROM</th>
                        <th>NAME</th>
                        <th>PHONE</th>
                        <th />
                      </tr>
                    </thead>
                    <tbody>
                      {voicemails.length ? (
                        voicemails.map((voicemail) => {
                          return (
                            <VoicemailRow
                              key={voicemail.id}
                              voicemail={voicemail}
                              onPlay={this.onVoicemailPlayClick}
                              onReadToggle={this.onReadToggleClick}
                            />
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan="6">No Voicemails Found</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                ) : (
                  <div className="voicemails__list__table_loader">
                    <Loading />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Voicemails.defaultProps = {
  getVoicemails: () => {},
  markVoicemail: () => {},
};

Voicemails.propTypes = {
  markVoicemail: PropTypes.func,
  getVoicemails: PropTypes.func,
  voicemails: PropTypes.shape({
    list: PropTypes.array,
  }).isRequired,
};
